import React, { FunctionComponent, useMemo, useState } from "react";
import { GroupWorkSpace } from "./WorkspacesContainer";
import WorkspaceHeader from "./WorkspaceHeader";
import { Nav, Tab, TabContainer, TabContent, TabPane } from "react-bootstrap";
import { Attendance, InterventionGroup } from "../../../../../../../../store/onboarding/cases/types";
import AttendanceTab from "./attendance-tab/AttendanceTab";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../../../../../../../store";
import LoggedProgressTab from "./LoggedProgressTab";
import LoggedInterventionsTab from "./LoggedInterventionsTab";
import MatrixTab from "../../../../../../../common/reading-interventions/intervention-tools/recommend-groups/group-card/focus-section/MatrixTab";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartLine, faList } from "@fortawesome/free-solid-svg-icons";
import {
  hideInterventionPlanModal,
  showInterventionPlanModal,
} from "../../../../../../../../store/onboarding/cases/actions";
import {
  openGoalProgressModal,
  openImplementationCheckModal,
} from "../../../../../../../../store/onboarding/meeting-module/actions";
import InterventionGroupLoggingTab from "./InterventionGroupLoggingTab";
import useUserAssignedToGroup from "../../hooks/useUserAssignedToGroup";
import useInterventionGroupAccess from "../../../../../../../../utils/hooks/useInterventionGroupAccess";
import { EventKey } from "react-bootstrap/esm/types";
import AlertHistoryTab from "./AlertHistoryTab";
import useUserRole from "../../../../../../../../utils/hooks/useUserRole";

type Props = {
  interventionGroup: InterventionGroup;
  expanded?: boolean;
  workspace: GroupWorkSpace;
  studentId?: number;
  setExpandedWorkSpace: React.Dispatch<
    React.SetStateAction<GroupWorkSpace | undefined>
  >;
};

enum TabKeys {
  LoggedGoalProgress = "LoggedGoalProgress",
  LoggedInterventions = "LoggedInterventions",
  Feedback = "Feedback",
  Attendance = "Attendance",
  Focuses = "SkillFocuses",
  ActionsTaken = "ActionsTaken",
  StudentProgressAlerts = "StudentProgressAlerts",
}

const LoggedDataWorkspace: FunctionComponent<Props> = (props) => {
  const {
    interventionGroup,
    expanded,
    workspace,
    studentId,
    setExpandedWorkSpace,
  } = props;

  const dispatch = useDispatch();

  const { isUserAssignedToGroup } = useUserAssignedToGroup(interventionGroup);

  const isStudentDetail =  useSelector(
    (s: ApplicationState) => s.cases.isStudentDetail
  );

  const isGroupDetail =  useSelector(
    (s: ApplicationState) => s.cases.isGroupDetail
  );

  const { isIntGrpIDsWithReadAccess } = useInterventionGroupAccess(interventionGroup.id);

  const notShareDataWith =  useSelector(
    (s: ApplicationState) => s.cases.notShareDataWith
  );

  const { isDistrictOwner } = useUserRole()

  const [activeTab, setActiveTab] = useState<string | null>(TabKeys.Attendance);

  const { selectedStudents, showOnlyActiveInterventions } = useSelector(
    (s: ApplicationState) => s.cases.modalsState.interventionPlan
  );

  const [showUpsertForm, setShowUpsertForm] = useState<boolean>(false);
  const [selectedAttendance, setSelectedAttendance] = useState<
    Attendance | undefined
  >();

  const handleLogGoalProgress = () => {
    dispatch(hideInterventionPlanModal());
    dispatch(
      openGoalProgressModal({
        onClose: () => {
          dispatch(showInterventionPlanModal());
        },
      })
    );
  };

  const handleLogIntervention = () => {
    setActiveTab(TabKeys.LoggedInterventions);
    dispatch(hideInterventionPlanModal());
    dispatch(
      openImplementationCheckModal({
        onClose: () => dispatch(showInterventionPlanModal()),
      })
    );
  };

  return (
    <div>
      <WorkspaceHeader
        expanded={expanded}
        workspace={workspace}
        setExpandedWorkSpace={setExpandedWorkSpace}
        header={"Logged Data"}
      />
      <div className="workspace-body">
        {!isStudentDetail && !isGroupDetail && !isIntGrpIDsWithReadAccess &&
          <div className="d-flex justify-content-between mb-2">
            <button
              className="blueBtnSm mr-1"
              onClick={() => {
                setActiveTab(TabKeys.Attendance);
                setShowUpsertForm(true);
                setSelectedAttendance(undefined)
              }}
            >
              Add New Attendance
            </button>

            <button className="blueBtnSm mx-1" onClick={handleLogGoalProgress}>
              <FontAwesomeIcon
                icon={faChartLine}
                size={"lg"}
                style={{ color: "white", marginRight: "0.5rem" }}
              />
              log goal progress
            </button>

            <button className="blueBtnSm ml-1" onClick={handleLogIntervention}>
              <FontAwesomeIcon
                icon={faList}
                size={"lg"}
                style={{ color: "white", marginRight: "0.5rem" }}
              />{" "}
              log intervention
            </button>
          </div>
        }

        <TabContainer activeKey={activeTab as EventKey} onSelect={setActiveTab}>
          <div
            className="d-flex flex-wrap border p-2 bg-light loggedDataTable"
            style={{ maxWidth: "100%" }}
          >
            <Nav.Item className="mr-2 mb-2">
              <Nav.Link
                eventKey={TabKeys.Attendance}
                className={`text-dark border rounded-0 py-1 px-3 ${
                  activeTab === TabKeys.Attendance ? "active font-weight-bold" : "bg-secondary-subtle"
                }`}
                style={{
                  fontSize: "16px",
                  borderBottom: activeTab === TabKeys.Attendance ? "none" : undefined,
                  height: "unset"
                }}
              >
                <div>Attendance</div>
              </Nav.Link>
            </Nav.Item>
            <Nav.Item className="mr-2 mb-2">
              <Nav.Link
                eventKey={TabKeys.LoggedGoalProgress}
                className={`text-dark border rounded-0 py-1 px-3 ${
                  activeTab === TabKeys.LoggedGoalProgress ? "active font-weight-bold" : "bg-secondary-subtle"
                }`}
                style={{
                  fontSize: "16px",
                  borderBottom: activeTab === TabKeys.LoggedGoalProgress ? "none" : undefined,
                  height: "unset"
                }}
              >
                <div>Logged Goal Progress</div>
              </Nav.Link>
            </Nav.Item>
            {isStudentDetail ?
              (isUserAssignedToGroup ?
                <Nav.Item className="mr-2 mb-2">
                  <Nav.Link
                    eventKey={TabKeys.LoggedInterventions}
                    className={`text-dark border rounded-0 py-1 px-3 ${
                  activeTab === TabKeys.LoggedInterventions ? "active font-weight-bold" : "bg-secondary-subtle"
                }`}
                style={{
                  fontSize: "16px",
                  borderBottom: activeTab === TabKeys.LoggedInterventions ? "none" : undefined,
                  height: "unset"
                }}
                  >
                    <div>Logged Interventions</div>
                  </Nav.Link>
              </Nav.Item>
                : '')
            :
            !notShareDataWith ? 
              <Nav.Item className="mr-2 mb-2">
                <Nav.Link
                  eventKey={TabKeys.LoggedInterventions}
                  className={`text-dark border rounded-0 py-1 px-3 ${
                  activeTab === TabKeys.LoggedInterventions ? "active font-weight-bold" : "bg-secondary-subtle"
                }`}
                style={{
                  fontSize: "16px",
                  borderBottom: activeTab === TabKeys.LoggedInterventions ? "none" : undefined,
                  height: "unset"
                }}
                >
                  <div>Logged Interventions</div>
                </Nav.Link>
              </Nav.Item>
            : ''}
            <Nav.Item className="mr-2 mb-2">
              <Nav.Link eventKey={TabKeys.Focuses} className={`text-dark border rounded-0 py-1 px-3 ${
                  activeTab === TabKeys.Focuses ? "active font-weight-bold" : "bg-secondary-subtle"
                }`}
                style={{
                  fontSize: "16px",
                  borderBottom: activeTab === TabKeys.Focuses ? "none" : undefined,
                  height: "unset"
                }}>
                <div>Skill Focuses</div>
              </Nav.Link>
            </Nav.Item>
            <Nav.Item className="mr-2 mb-2">
              <Nav.Link
                eventKey={TabKeys.ActionsTaken}
                className={`text-dark border rounded-0 py-1 px-3 ${
                  activeTab === TabKeys.ActionsTaken ? "active font-weight-bold" : "bg-secondary-subtle"
                }`}
                style={{
                  fontSize: "16px",
                  borderBottom: activeTab === TabKeys.ActionsTaken ? "none" : undefined,
                  height: "unset"
                }}
              >
                <div>Actions Taken</div>
              </Nav.Link>
            </Nav.Item>
            {!isDistrictOwner && (
            <Nav.Item className="mr-2 mb-2">
              <Nav.Link
                eventKey={TabKeys.StudentProgressAlerts}
                className={`text-dark border rounded-0 py-1 px-3 ${
                  activeTab === TabKeys.StudentProgressAlerts ? "active font-weight-bold" : "bg-secondary-subtle"
                }`}
                style={{
                  fontSize: "16px",
                  borderBottom: activeTab === TabKeys.StudentProgressAlerts ? "none" : undefined,
                  height: "unset"
                }}
              >
                <div>Students Progress Alerts</div>
              </Nav.Link>
            </Nav.Item>
            )}
          </div>
          <TabContent className={"workspace-content-container border"} style={{ borderTop: "none" }}>
            <Tab.Pane eventKey={TabKeys.Attendance}>
              <div className="p-3">
                <AttendanceTab
                  showUpsertForm={showUpsertForm}
                  setShowUpsertForm={setShowUpsertForm}
                  selectedAttendance={selectedAttendance}
                  setSelectedAttendance={setSelectedAttendance}
                  interventionGroup={interventionGroup}
                  onlyActive={showOnlyActiveInterventions}
                  isStudentDetail={isStudentDetail}
                  isGroupDetail={isGroupDetail}
                  studentId={studentId}
                />
              </div>
            </Tab.Pane>
            <TabPane eventKey={TabKeys.LoggedGoalProgress}>
              <div className="logged-data-table sticky-table-header-wrapper">
                <LoggedProgressTab
                  selectedStudents={selectedStudents}
                  interventionGroup={interventionGroup}
                  isStudentDetail={isStudentDetail}
                  isGroupDetail={isGroupDetail}
                  expanded={expanded}
                />
              </div>
            </TabPane>
            <TabPane eventKey={TabKeys.LoggedInterventions}>
              <div className="logged-data-table sticky-table-header-wrapper">
                <LoggedInterventionsTab
                  interventionGroup={interventionGroup}
                  onlyActive={showOnlyActiveInterventions}
                  isStudentDetail={isStudentDetail}
                  isGroupDetail={isGroupDetail}
                />
              </div>
            </TabPane>
            <TabPane eventKey={TabKeys.Focuses}>
              <div className="p-3">
              {interventionGroup.recommendation_group_key
              ?
                <MatrixTab
                  interventionGroup={interventionGroup}
                  students={interventionGroup.students}
                  specifics={interventionGroup.focuses ?? []}
                  showFullNames
                />
              : <div className="text-center">No Skill Focuses.</div>
              }
              </div>
            </TabPane>
            <TabPane eventKey={TabKeys.ActionsTaken}>
              {activeTab == "ActionsTaken" && (
                <div className="logged-data-table sticky-table-header-wrapper">
                    <InterventionGroupLoggingTab
                      interventionGroup={interventionGroup}
                      studentId={studentId}
                    />
                </div>
              )}
            </TabPane>
            {!notShareDataWith  && !isDistrictOwner && (
              <TabPane eventKey={TabKeys.StudentProgressAlerts}>
                {activeTab == "StudentProgressAlerts" &&
                <div className="logged-data-table sticky-table-header-wrapper">
                  <AlertHistoryTab 
                    selectedStudents={selectedStudents}
                    interventionGroup={interventionGroup}
                    isStudentDetail={isStudentDetail}
                    isGroupDetail={isGroupDetail}
                    studentId={studentId}
                    expanded={expanded}
                  />
                </div>
                }
              </TabPane>
            )}
          </TabContent>
        </TabContainer>
      </div>
    </div>
  );
};

export default LoggedDataWorkspace;
